// extracted by mini-css-extract-plugin
export default {"form":"StudentLogin_form__59gUg","forgot-password":"StudentLogin_forgot-password__CZMWw","GoogleButton":"StudentLogin_GoogleButton__yG22z"};